$(document).on('turbolinks:load', function() {
  $('#vehicles-table').dataTable({
    "processing": true,
    "serverSide": true,
    "ajax": {
      "url": $('#vehicles-table').data('source')
    },
    "pagingType": "full_numbers",
    "columns": [
      {"data": "name"},
      {"data": "ops"},
    ], 
    columnDefs: [{ "orderable": false, "targets": 1 }, { "width": "5%", "targets": 1 }]
  });
});